module.exports = __webpack_public_path__ + "static/media/Animal Horse.19086c5e.svg";